export default __webpack_public_path__ + "static/media/bbp-new-campaign-large.86363a0f.png";